/**
 * Mock Priority Counts Data
 * Matches the actual API response structure
 */
export const mockPriorityCounts = {
  success: true,
  'priority-counts': {
    high: 2,
    medium: 2,
    low: 1,
  },
  'x-hits': 5,
}
